module.exports = "https://www.gc-qa.gnp.com.mx/1f39787e52da73530f8ddf5b59f4bc60.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/close-icono.png
// module id = 324
// module chunks = 0 1